// Kept free of imports so the API helpers can use it headlessly.
export const isMobile = () => {
	const mobile = /(?:phone|windows\s+phone|ipod|blackberry|(?:android|bb\d+|meego|silk|googlebot) .+? mobile|palm|windows\s+ce|opera\smini|avantgo|mobilesafari|docomo)/i;
	const tablet = /(?:ipad|playbook|(?:android|bb\d+|meego|silk)(?! .+? mobile))/i;
	return mobile.test(navigator.userAgent) || tablet.test(navigator.userAgent) || isIpad();
}

export const isIpad = () => {
	return ((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) && !window.MSStream) || navigator.userAgent.match(/(iPad)/);
}
